module.exports = __webpack_public_path__ + "img/XK.cb2adcf2.svg";